import axios, { AxiosPromise, AxiosRequestConfig, AxiosResponse } from 'axios'
import { AlrContainer } from '@/models/response/AlrContainer'
import { ApiResultCode } from '@/models/response/AlrBase'
import { AloError } from '@/models/alo/AloError'

let mocks:any = { 
}

let cacheQuery:{[index:string]: AxiosPromise<any>} = {}

const apiCall = ({url,method,...args}:AxiosRequestConfig):AxiosPromise<any> => {  
  const met =  method || 'GET'
  const methodeMock = mocks[url!] && mocks[url!][met]
  if(typeof methodeMock === "function" )
  {
    return new Promise<AxiosResponse<any>>((resolve, reject) => {
      try {
        console.log(`Mocked '${url}' - ${met}`)
        setTimeout(() => {
          resolve(methodeMock(args))          
          console.log('response: ', methodeMock(args))
        }, 50)
      }
      catch (err) {
        //@ts-ignore
        reject(new Error(err))
      }
    })
  }  

  //gestion du cache d'appel d'une promise
  const axiosConfig = { url, method: met, ...args }
  //certainement couteux mais moins que plusieurs appel successif a une meme ressource
  const axiosConfiStr = JSON.stringify(axiosConfig)
  //si la promise est déja mémorisé on la retourne
  //@ts-ignore
  if(cacheQuery[axiosConfiStr])  return cacheQuery[axiosConfiStr]
  //memorise la promise pendant son appel
  cacheQuery[axiosConfiStr] = axios(axiosConfig)
  cacheQuery[axiosConfiStr].finally(() => {     
      //supprime la promise du cache une fois la requete fini 
      delete cacheQuery[axiosConfiStr]
  })  
  return cacheQuery[axiosConfiStr]
}


const externalApiCall = ({ url, method, ...args }:AxiosRequestConfig):AxiosPromise<any> => {
  const methodeMock = mocks[url!] && mocks[url!][method || 'GET']
  if(typeof methodeMock !== "function" ) {
    //on memorise le token d'authorisation
    const authorization = axios.defaults.headers.common['authorization']    
    //on le supprime avant de faire la requete externe
    delete axios.defaults.headers.common['authorization']          
    const promise = axios({ url, method: method || 'GET', ...args })
    //on reaffecte le header
    axios.defaults.headers.common['authorization'] = authorization
    return promise
  }
  return apiCall({ url, method, ...args })      
}


//ajoute des mocks et fait en sorte que la reponse soit encapsulé dans un axios response valid
const addMocks = (mks:any) => {  
  
  Object.keys(mks).forEach(url => {
    Object.keys(mks[url]).forEach(key => {
      if(!mocks[url]) mocks[url] = {}
      mocks[url][key] = ({...args}:any):AxiosResponse<any> => {
        return {
          data : mks[url][key](args),
          status: 200,
          statusText: 'Ok',
          //@ts-ignore
          headers: null,
          //@ts-ignore
          config: {}
        }
      } 
    })
  })
}

export const directQuery = <T>(
  request: () => AxiosPromise<AlrContainer<T>>) => {
    return new Promise<T>((resolve, reject) => {  
      request()
        .then(resp => {
        if (resp.data.resultCode == ApiResultCode.Ok) {
          const item = resp.data.data as T                    
          resolve(item)            
        } else {                    
          reject((resp.data.data as AloError).errorMessage)
        }
      })
      .catch(err => {                
        reject(err)
      })
    })  
}

export const directPayloadQuery = <T,T2>(
  request: ((payload:T2) => AxiosPromise<AlrContainer<T>>),
  payload:T2
) => {
return new Promise<T>((resolve, reject) => {  
    request(payload)
    .then(resp => {
    if (resp.data.resultCode == ApiResultCode.Ok) {
      const item = resp.data.data as T                    
      resolve(item)            
    } else {                    
      reject((resp.data.data as AloError).errorMessage)
    }
  })
  .catch(err => {                
    reject((err?.response?.data?.data as AloError)?.errorMessage??err)
  })
})  
}


const downloadFile = (url:string, ext:string ='') => {
  return axios({
    url,
    method: 'GET',
    responseType: 'blob', // important
  }).then((response) => {          
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
    var matches = filenameRegex.exec(response.headers['content-disposition']);
    if (matches != null && matches[1]) {             
      link.setAttribute('download', `${matches[1].replace(/['"]/g, '')}${ext}`) //or any other extension
      document.body.appendChild(link)
      link.click()
      link.parentNode!.removeChild(link)
    }                    
  })
}

export default {
  apiCall,
  externalApiCall,
  addMocks,
  downloadFile
}
 